import { Navigate } from 'react-router-dom';

import { PagePaths } from '@constants/paths';
import { energyRoutes } from '@features/Energy/energyRoutes';
import { mobileRoutes } from '@features/Mobile/routes';
import { PartnerPresentationRebrand } from '@pages/PartnerPresentation';
import { Referral } from '@pages/Referral';
import {
  Address,
  Basket,
  BoilerCover,
  Broadband,
  Bundle,
  Cashback,
  DepositPage,
  DetailsPage,
  Energy,
  ErrorBoundary,
  IncomeProtector,
  Insurance,
  Landing,
  Mobile,
  PartnerSetUp,
  RemoteInvite,
  RemoteJoin,
  RemoteLobby,
  RemotePreJoin,
  SaveForLater,
  ThankYouPage,
} from '@pages/index.ts';
import { UpdatedTariffModalProvider } from '@providers/basket';
import { AuthGuard } from '@routing/AuthGuard';
import { BasketGuard } from '@routing/BasketGuard';
import { RouteProvider } from '@routing/RouteProvider';
import { routes as authRoutes } from '@services/Auth';

const routesConfig = [
  {
    path: '',
    element: <RouteProvider />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        path: '/',
        element: <Landing />,
      },
      {
        path: '/address',
        element: <Address />,
      },
      { ...authRoutes },
      {
        path: '/ref/:id',
        element: <Referral />,
      },
      {
        path: '/remote/start',
        element: <RemoteInvite />,
      },
      {
        path: '/remote/join/:code?',
        element: <RemoteJoin />,
      },
      {
        path: '/remote/setup',
        element: <RemotePreJoin />,
      },
      {
        path: '/remote/lobby',
        element: <RemoteLobby />,
      },
      {
        path: '/basket/:basketId',
        element: <Basket />,
      },
      {
        path: PagePaths.Bundle,
        element: (
          <UpdatedTariffModalProvider>
            <BasketGuard />
          </UpdatedTariffModalProvider>
        ),
        children: [
          {
            path: '',
            element: <Bundle />,
          },
          {
            path: PagePaths.Energy,
            element: <Energy />,
            children: [energyRoutes],
          },
          {
            path: PagePaths.Broadband,
            element: <Broadband />,
          },
          {
            path: PagePaths.Mobile,
            element: <Mobile />,
            children: [mobileRoutes],
          },
          {
            path: PagePaths.SaveForLater,
            element: <SaveForLater />,
          },
          {
            path: PagePaths.Insurance,
            children: [
              {
                path: '',
                element: <Insurance />,
              },
              {
                path: PagePaths.BHC,
                element: <BoilerCover />,
              },
              {
                path: PagePaths.IP,
                element: <IncomeProtector />,
              },
            ],
          },
          {
            path: PagePaths.Cashback,
            element: <Cashback />,
          },
        ],
      },
      {
        path: PagePaths.Order,
        element: <BasketGuard />,
        children: [
          {
            path: PagePaths.Confirm,
            element: (
              <UpdatedTariffModalProvider>
                <DetailsPage />
              </UpdatedTariffModalProvider>
            ),
          },
          {
            path: PagePaths.ThankYou,
            element: <ThankYouPage />,
          },
          {
            path: PagePaths.Deposit,
            element: <DepositPage />,
          },
        ],
      },
      {
        path: PagePaths.Partner,
        element: <AuthGuard />,
        children: [
          {
            path: '',
            element: <PartnerSetUp />,
          },
        ],
      },
      {
        path: PagePaths.Presentation,
        element: <PartnerPresentationRebrand />,
      },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ],
  },
];

export { routesConfig };
